export class SeguimientoModel {

    titulo: string;
    ubicacion: string;
    fecha: string;
    conductor: string;
    vehiculo: number;
  
    constructor(
        titulo,
        ubicacion,
        fecha,
        conductor,
        vehiculo
                ) {
      this.titulo = titulo;
      this.ubicacion = ubicacion;
      this.fecha = fecha;
      this.conductor = conductor;
      this.vehiculo = vehiculo;
    }
  
  }